import { render, staticRenderFns } from "./confirmDetail.vue?vue&type=template&id=067665a2&scoped=true"
import script from "./confirmDetail.vue?vue&type=script&lang=js"
export * from "./confirmDetail.vue?vue&type=script&lang=js"
import style0 from "./confirmDetail.vue?vue&type=style&index=0&id=067665a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "067665a2",
  null
  
)

export default component.exports